module.exports = __webpack_public_path__ + "img/zxfl@2x.9f2831c0.png";